import Servico from './Servico';
import ServicoConfig from './servicoConfig';

export default Servico;

export { ServicoConfig };
